// extracted by mini-css-extract-plugin
export default {"container":"basic-button_container__SXNxm"};